import axios from 'axios'
import Vue from 'vue'

const API = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  adminURL: process.env.VUE_APP_ADMIN_URL,
  timeout: 180000, // 180 sec.
  headers: {
    'Authorization': `Bearer ${window.localStorage.getItem('auth_token')}`,
    'Content-Type': 'application/json'
  }
});

window.serverConfig = undefined;
API.interceptors.request.use((request) => {
  return new Promise((resolve, reject) => {
    if (window.serverConfig) {
      request.baseURL = window.serverConfig.apiURL || request.baseURL;
      return resolve(request);
    }

    fetch('/config/config.json').then(response => response.json()).then(config => {
      window.serverConfig = config;
      Vue.prototype.config = config;
      request.baseURL = config.apiURL || request.baseURL;
      resolve(request);
    }).catch(e => reject(e));
  })
});

API.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    window.localStorage.removeItem('auth_token');
    window.location.href = '/login';
  }
  throw error;
});

export default API
